<template>
  <div>
    <a-modal
      width="650px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="项目配置"
      @ok="handleSubmit"
    >
      <a-spin :spinning="loading">
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-form-item label="产品名称">
            <a-input :value="data.product_name" disabled />
          </a-form-item>

          <a-form-item label="采购数量">
            <a-input :value="data.product_count" disabled />
          </a-form-item>

          <a-form-item label="Profile供应商">
            <a-select
              v-decorator="['profile_supplier_id', {
                rules: [{ required: true, message: '请选择Profile供应商' }]
              }]"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择Profile供应商"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="option in supplierOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { findProfileSuppliers } from '@/api/profile_supplier'
import {
  findAgentPurchaseItemProfileConfigureForm,
  approveProfilePurchaseItem
} from '@/api/agent_purchase_item'

export default {
  name: 'ConfigureProfilePurchaseItem',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      loading: true,
      submitting: false,
      loadingSupplierOptions: false,
      supplierOptions: [],
      form: this.$form.createForm(this, { name: 'configure_profile_purchase_item' })
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchSupplierOptions()
    this.fetchData()
  },
  methods: {
    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      }).catch(() => {
        this.loadingSupplierOptions = false
      })
    },

    fetchData() {
      this.loading = true
      findAgentPurchaseItemProfileConfigureForm(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.$nextTick(() => {
            this.form.setFieldsValue({
              profile_supplier_id: res.data.profile_supplier_id === 0
                ? undefined
                : res.data.profile_supplier_id
            })
          })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleSubmit(e) {
      if (e && e.preventDefault) e.preventDefault()
      if (this.submitting) return
      this.form.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        approveProfilePurchaseItem(this.id, values).then((res) => {
          this.submitting = false
          if (res.code === 0) {
            this.isShow = false
            this.$emit('completed')
          }
        }).catch(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>
